import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { transactionsSelector } from '@/state/transactions/slices/index.slices'
import { useTransactionsActions } from './use-transactions-actions.hooks'
import { TransactionsFilters } from '@/state/transactions/models'

export const useTransactionsFilters = () => {
  const { getAllTransactions, setTransactionsFilters } =
    useTransactionsActions()

  const { filters, pagination } = useSelector(transactionsSelector)

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: Partial<TransactionsFilters>) => {
      getAllTransactions(newFilters)
    }, 500),
    [],
  )

  const handleChangeSearch = (
    newFilter: Partial<TransactionsFilters>,
    debounce?: boolean,
  ) => {
    const newFilters = {
      ...filters,
      ...newFilter,
      page: 1,
    }

    setTransactionsFilters(newFilters)

    if (debounce) {
      filterDelay(newFilters)
    } else {
      getAllTransactions(newFilters)
    }
  }

  const handleChangePage = (newPage: number) => {
    setTransactionsFilters({ ...filters, page: newPage })
    getAllTransactions({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setTransactionsFilters({ ...filters, limit: newLimit, page: 1 })
      getAllTransactions({ ...filters, limit: newLimit, page: 1 })
    } else {
      setTransactionsFilters({ ...filters, limit: newLimit })
      getAllTransactions({ ...filters, limit: newLimit })
    }
  }

  const submitSearchFilter = () => {
    getAllTransactions(filters)
  }

  return {
    filters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
    submitSearchFilter,
  }
}
